const timeForView = (number) => {
  return String(number).length < 2 ? `0${number}` : number;
};

export const timeHelper = (date) => {
  return `${timeForView(new Date(date).getDate())}.${timeForView(
    new Date(date).getMonth() + 1
  )}.${timeForView(new Date(date).getFullYear())}, ${timeForView(
    new Date(date).getHours()
  )}:${timeForView(new Date(date).getMinutes())}:${timeForView(new Date(date).getSeconds())}`;
};

export const roundGameTimeTextHelper = (text) => {
  const parts = text.split(' ');
  const numberPart = parts.find((part) => !Number.isNaN(Number(part)));
  const textPart = parts.find((part) => Number.isNaN(Number(part)));
  return [numberPart, textPart];
};
